import type { StrictOmit } from '@enmon/commons';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import type { SerializedTenant } from '@enmon/commons/lib/enmon';
import { COMMON_FORM_FIELDS_TRANSLATED } from '../form';

type TranslatedKeys =
  | keyof StrictOmit<SerializedTenant, '_id' | '__v' | 'createdAt' | 'updatedAt' | 'customer' | 'contact'>
  | 'contactName'
  | 'contactEmail'
  | 'contactPhone';

export const TENANT_FIELDS_TRANSLATED = defineMessages<TranslatedKeys>({
  name: COMMON_FORM_FIELDS_TRANSLATED.name,
  identificationNumber: {
    id: 'app.common.tenant.fields.identificationNumber',
  },
  contactName: { id: 'app.common.tenant.fields.contactName' },
  contactEmail: COMMON_FORM_FIELDS_TRANSLATED.email,
  contactPhone: COMMON_FORM_FIELDS_TRANSLATED.phone,
});
